module.exports = __webpack_public_path__ + "media/images/badges/purebarre/PureBarre-6500-Classes-Active-d24b2d4f53a83e11cb5f60ddfc1c69fd.png";